import React from "react"
import { Box } from "@mui/material"

import AnalyzersFeaturesSelector from "Pages/AnalyzersV2/@components/Table/Toolbar/FeaturesSelector"
import AnalyzerTableActions from "Pages/AnalyzersV2/@components/Table/Toolbar/Actions"
import ToggleTableDetails from "./ToggleDetails";
import ToggleDecisions from "./ToggleDecisions";
import DecisionsNote from "./DecisionsNote";
import { AppCardTitle } from "@components"
import { analyzerDate, lengthRental, offices, officesOptions, repricingPass, repricingPassesInfo } from "@signals"
import { responseData } from "Pages/AnalyzersV2/@signals"
import { passSubtitle } from "Pages/AnalyzersV2/@services/passCompare"
import CarPickRow from "Pages/AnalyzersV2/@components/CarPick/CarPickRow"


export default function AnalyzerTableToolbar({ isRating = false, isPosition = false, carPick = null }) {

	// with a repricing pass the table says what is open and what the % compares with (UX Obs. 4); with a report nothing
	// changes (decision 1, plan-review Obs. 11)
	const pass = repricingPass.value ? repricingPassesInfo.value.find(p => p.execution_id === repricingPass.value) : null
	const subtitle = passSubtitle({
		pass, section: responseData.value?.type,
		office: officesOptions.value.find(o => String(o.value) === String(offices.value))?.label,
		lor: lengthRental.value, date: analyzerDate.value,
	})

	return <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, width: "100%", mb: 1.5 }}>
		<AppCardTitle icon="table-cells" title="Analyzer: Price Table" subtitle={subtitle || undefined}/>
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flexWrap: "wrap", gap: 2, ml: "auto" }}>
			{/* Position pins its cell to price + gap, so neither the details toggle
			    nor the feature picker would change anything on screen. */}
			{/* with a pass open: the engine's decisions on the cells (CU-869fmm949) */}
			{!isPosition && !isRating && <ToggleDecisions />}
			{!isPosition && <ToggleTableDetails />}
			{!isRating && !isPosition && <AnalyzersFeaturesSelector/>}
			{/* The Min/Max switch is hidden for position: that analyzer only ever
			    works on min_price, so the Max tab would have no data behind it. */}
			{!isRating && !isPosition && <AnalyzerTableActions />}
		</Box>
		{/* the Cars selector of DOR, LOR and Rank Analyzer (CU-869fmpqfm, UX Obs. 2): a second row, row 1 unchanged */}
		{!!carPick && <CarPickRow onPick={carPick.onPick} isPosition={isPosition}/>}
		<Box sx={{ width: "100%", "&:empty": { display: "none" } }}><DecisionsNote/></Box>
	</Box>
}
